import MediaQuery from 'react-responsive';

export const Desktop = props => <MediaQuery {...props} minWidth={768} />;
export const Mobile = props => <MediaQuery {...props} maxWidth={767} />;
export const DesktopXL = props => <MediaQuery {...props} minWidth={1200} />;
export const MobileSmallUp = props => <MediaQuery {...props} minWidth={576} />;
export const MobileSmallDown = props => <MediaQuery {...props} maxWidth={575} />;




// WEBPACK FOOTER //
// ./helpers/MediaQueries.js